<template>
  <div id="readMore" v-if="readMore" :title="readMore.title" @click="click">
    {{ readMore.label }}
  </div>
</template>

<script>
//<a v-if="!edit" :href="readMore.href" :title="readMore.title" :target="readMore.target">{{ readMore.label }} </a>

export default {
  name: "ReadMore",
  props: {
    readMore: Object,
    edit: Boolean
  },
  methods: {
    click() {
      if (this.edit) {
        let message =
          "Öppnar url: " + this.readMore.href + " i " + (this.readMore.target == "_self" ? "detta fönster." : "ett nytt fönster.");
        if (window.confirm(message + "\nVill du testa länken? (Görs alltid i ett nytt fönster när du editerar)")) {
          window.open(this.readMore.href, "");
        }
      } else {
        if (this.readMore.target == "_self") {
          window.locaction = this.readMore.href;
        } else {
          window.open(this.readMore.href, "");
        }
      }
    }
  }
};
</script>

<style scoped>
div#slideList div.slideWrapper div.slide div#readMore {
  border-radius: 10px;
  cursor: pointer;
  background: var(--bg-message);
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
}

div#slideList div.slideWrapper div.slide div div#readMore a {
  color: white;
  text-decoration: none;
}

div#slideList div.slideWrapper div.slide div.contentDesktop div#readMore {
  max-width: fit-content;
}

div#slideList div.slideWrapper div.slide div.image div.contentDesktop div#readMore {
  /*max-width: none; ändrar bredden på knappen*/
  min-width: 100px;
}

div#slideList div.slideWrapper div.slide div#mobile div#readMore {
  margin-top: 10px;
  text-align: center;
}
</style>
